import React from "react";

const CardsBorder = ({ children }) => {
  return (
    <div className="w-full  border border-[#06513D] rounded-[10px] pt-[20px] shadow-[0px_0px_16px_0px_#3BA2B91F]">
      {children}
    </div>
  );
};

export default CardsBorder;
